<template>
  <div class="nav-container" @click="GotoTreasureView">
    <div class="nav-content">
    </div>
    
  </div>
</template>

<script setup>
// @ is an alias to /src
import { useRouter } from 'vue-router'

const router = useRouter()

const GotoTreasureView = async () => {
  // 尝试播放音乐
  if (window.playBgMusic && typeof window.playBgMusic === 'function') {
    await window.playBgMusic()
  }
  
  // 跳转到导航页面
  router.push({
    path: '/treasure',
  })
}


</script>

<style lang="scss" scoped>
.nav-container {
  background-image: url('../assets/nav_bg.jpg');
  background-size: cover;
  background-position: center top;
  background-repeat: no-repeat;
  position: relative; /* 关键：作为定位父级 */
  height: 100vh; /* 根据需求调整高度 */
  width: 100%; /* 根据需求调整宽度 */
  display: flex;
  flex-direction: column; /* 垂直排列 */
  padding-top: 332px;
  box-sizing: border-box;
  justify-content: flex-start; /* 确保子元素从顶部开始排列 */
  align-items: center; /* 水平居中对齐子元素 */
}

.nav-content{
  /* 设置背景图 */
  background-image: url('../assets/nav_title.png');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  width: 528px;
  height: 674px;
    /* 水平居中 */
  margin: 0 auto;
  position: relative;
  /* 垂直居中 */
  @media screen and (min-width: 1024px){
    transform: translateY(-20%);
  }
  &::before{
      content: '';
      width: 61px;
      height: 97px;
      background: url(~@/assets/choose/hand.png)no-repeat;
      background-size: 100% 100%;
      position: absolute;
      right: 0px;
      bottom: -150px;
      animation: dongBounce 1.2s ease-in-out infinite;
    }
}
@keyframes dongBounce {
      0%, 100% {
        transform: translateY(0) rotate(180deg);
      }
      50% {
        transform: translateY(-20px) rotate(180deg);
      }
    }
</style>